import { render, staticRenderFns } from "./ChangeTracker.vue?vue&type=template&id=8635eabc&scoped=true&"
import script from "./ChangeTracker.vue?vue&type=script&lang=js&"
export * from "./ChangeTracker.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTracker.vue?vue&type=style&index=0&id=8635eabc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8635eabc",
  null
  
)

export default component.exports